import React from "react"
import { Form } from "react-bootstrap"
import { injectIntl } from "react-intl"
import LabelSelect from "../label/selection.component"
import { LabelSelectFormGroupProps } from "../types/labelSelectFormGroup"

const LabelSelectFormGroup = (props: LabelSelectFormGroupProps) => {
    const { formLabel, labelSelectProps } = props

    return <Form.Group>
        <Form.Label htmlFor="labels" className="custom-form-label">
            {formLabel}
        </Form.Label>
        <LabelSelect {...labelSelectProps} />
    </Form.Group>
}

export default injectIntl(LabelSelectFormGroup)


// WEBPACK FOOTER //
// ./src/common/form/LabelSelectFormGroup.tsx